import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

export function DashboardSkeleton() {
  return (
    <Box component="div" id="main" sx={{ p: 2 }}>
      <Stack spacing={2}>
        <Skeleton variant="text" width={240} height={40} />
        <Skeleton variant="rectangular" height={120} />
        <Skeleton variant="rectangular" height={240} />
      </Stack>
    </Box>
  );
}
